import { PAGINATION_RECORD_PER_PAGE } from "../App/constants";

export const HASH_TAGS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const MAX_ALLOWED_HASH_TAG = 30;